import { Component, Input } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';

import { BusinessUserManagementPage } from '../../pages/business-user-management/business-user-management';
import { BusinessUserProvider } from '../../providers/business-user';

@Component({
  selector: 'user-card',
  templateUrl: 'user-card.html'
})
export class UserCardComponent {
	@Input('user') user;
	isDeleting: boolean = false;

	constructor(
		public businessUserProvider: BusinessUserProvider, 
		public navCtrl: NavController, 
		public alertCtrl: AlertController,
	) {

	}

	manageUser($e, user){
		this.navCtrl.push(BusinessUserManagementPage, {
	      user: user
	    });
	}	

	delete(user){
		if(this.isDeleting) return;
		
		let confirm = this.alertCtrl.create({
		  title: 'Remove user?',
		  message: 'Are you sure you want to delete this user?',
		  buttons: [
		    {
		      text: 'No',
		      handler: () => {
		        console.log('Disagree clicked');
		      }
		    },
		    {
		      text: 'Yes',
		      handler: () => {
		      	this.isDeleting = true;

				this.businessUserProvider.deleteUser({
					Id: user.Id,
					cb: (resp)=>{
						this.isDeleting = false;

						this.afterDelete(resp);
					}
				});				
		      }  
		    }
		  ]
		});

		confirm.present();		
	}

	afterDelete(resp){
		if(resp.Success==false){
			let alert = this.alertCtrl.create({
				title: 'Server response',
				subTitle: resp.Message,
				buttons: ['Dismiss']
			});

			alert.present();	
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/user-card/user-card.ts